import { render } from "./AllOrdersIcon.vue?vue&type=template&id=b5b0f720"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/Icons/AllOrdersIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b5b0f720"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b5b0f720', __exports__)) {
    api.reload('b5b0f720', __exports__)
  }
  
  module.hot.accept("./AllOrdersIcon.vue?vue&type=template&id=b5b0f720", () => {
    api.rerender('b5b0f720', render)
  })

}


export default __exports__